import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import axios from "axios";

function Community() {
  const [Communities, setCommunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCommunities = async () => {
      const url = `${process.env.REACT_APP_API_BASE_URL}/unito/community/all`;
      // const token = localStorage.getItem("token");
      // console.log(token);
      console.log("Fetching from:", url);

      try {
        const headers = {
          'Content-Type': 'application/json',
        };
        // if (token) {
        //   headers['Authorization'] = `Bearer ${token}`;
        // } else {
        //   console.warn("No token found in localStorage.");
        // }

        const response = await axios.get(url, { headers });
        console.log("Fetched Data:", response.data);
        console.log(response.data);
        setCommunities(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Fetch error:", error);
        setError("Failed to load Communities."); 
        setLoading(false);
      }
    };

    fetchCommunities();
  }, []);

  if (loading) {
    return <div className="text-white text-center p-4">Loading...</div>;
  }

  if (error) {
    return <div className="text-white text-center p-4">
      <p>fetching problem:</p>
      {error}
      </div>;
  }

  if (Communities.length === 0) {
    return (
      <>
        <div className="text-white text-center p-4">No Communities Found At The Moment</div>
        <button className="rounded-lg bg-cyan-400 text-black items-center p-6">Create Community</button>
      </>
    );
  }

  return (
    <div className="flex min-h-screen bg-[#181A20]">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 transition-all duration-300 px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <h1 className="text-3xl font-bold text-white">Communities</h1>
            <button className="bg-gradient-to-r from-violet-500 to-red-500 text-black hover:from-red-500 hover:to-violet-500 duration-300 font-semibold py-2 px-6 rounded-lg shadow transition">
              Search For Communities
            </button>
          </div>
          <hr className="my-6 border-t-2 border-gray-700" />
          <ul className="grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {Communities.map((community) => (
              <li
                key={community.id}
                className="bg-[#23272F] p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col justify-between"
              >
                <div>
                  <h2 className="text-2xl font-semibold text-white mb-2">
                    {community.communityName || "Untitled Community"}
                  </h2>
                  <p className="text-gray-400 text-sm mb-4">
                    Total Members: <span className="font-bold">{community.totalMembers}</span>
                  </p>
                </div>
                <a href={`/community/join/${community.id}`} className="mt-auto">
                  <button className="w-full bg-gradient-to-r from-violet-500 to-red-500 text-white font-semibold py-2 px-4 rounded-lg hover:from-red-500 hover:to-violet-500 transition-all duration-300">
                    Join Community
                  </button>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Community;
